function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  className: "outline",
  fill: "#919EAB",
  d: "M2,18.16 L2,14.16 L5.382,14.16 L6.105,15.607 C6.275,15.946 6.621,16.16 7,16.16 L13,16.16 C13.379,16.16 13.725,15.946 13.895,15.607 L14.618,14.16 L18,14.16 L18,18.16 L2,18.16 Z M19,1.16 C19.5522847,1.16 20,1.60771525 20,2.16 L20,19.16 C20,19.7122847 19.5522847,20.16 19,20.16 L1,20.16 C0.44771525,20.16 6.76353751e-17,19.7122847 0,19.16 L0,2.16 C-6.76353751e-17,1.60771525 0.44771525,1.16 1,1.16 L5,1.16 C5.55228475,1.16 6,1.60771525 6,2.16 C6,2.71228475 5.55228475,3.16 5,3.16 L2,3.16 L2,12.16 L6,12.16 C6.379,12.16 6.725,12.374 6.895,12.713 L7.618,14.16 L12.382,14.16 L13.105,12.713 C13.275,12.374 13.621,12.16 14,12.16 L18,12.16 L18,3.16 L15,3.16 C14.4477153,3.16 14,2.71228475 14,2.16 C14,1.60771525 14.4477153,1.16 15,1.16 L19,1.16 Z M6.293,3.29403485 C6.04041322,3.54662162 5.94176685,3.91477487 6.03422003,4.25981482 C6.1266732,4.60485477 6.39618008,4.87436165 6.74122003,4.96681482 C7.08625998,5.059268 7.45441323,4.96062163 7.707,4.70803485 L9,3.41503485 L9,9.00103485 C9,9.5533196 9.44771525,10.0010349 10,10.0010349 C10.5522847,10.0010349 11,9.5533196 11,9.00103485 L11,3.41503485 L12.293,4.70803485 C12.5455868,4.96062164 12.91374,5.05926801 13.25878,4.96681484 C13.6038199,4.87436166 13.8733268,4.60485478 13.96578,4.25981482 C14.0582332,3.91477487 13.9595868,3.54662162 13.707,3.29403485 L10.707,0.294034852 C10.5198649,0.105825612 10.2654096,0 10,0 C9.73459037,0 9.48013513,0.105825612 9.293,0.294034852 L6.293,3.29403485 Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/payouts.53178433.svg";
export { SvgComponent as ReactComponent };